import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NbSelectModule, NbMenuModule, NbCheckboxModule } from '@nebular/theme';

import { AuthModule } from '../@auth/auth.module';

import { AdminRoutingModule } from './admin-routing.module';
import { AdminComponent } from './admin.component';
import { AdminPagesMenu } from './admin-pages-menu';
import { ThemeModule } from 'app/@theme/theme.module';
import { ConvertToGramPipe } from 'app/@theme/pipes';

const PAGES_COMPONENTS = [AdminComponent];

@NgModule({
  imports: [
    CommonModule,
    AdminRoutingModule,
    ThemeModule,
    AuthModule,
    NbMenuModule,
    NbSelectModule,
    NbCheckboxModule,
  ],
  declarations: [AdminComponent, ...PAGES_COMPONENTS],
  providers: [AdminPagesMenu],
})
export class AdminModule {}
